<!--
 * @Author: your name
 * @Date: 2020-04-23 17:57:27
 * @LastEditTime: 2021-07-26 09:15:15
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \szny-official-website\src\components\Footer\index.vue
-->
<template>
    <div id="app">
      <div class="page-footer ui-flex ui-flex-justify-center">
        <div class="ele-wrap ui-flex ui-flex-justify-space-between">
          <div class="footer-part1 ui-flex">
            <div class="part1-column" :key="value.id" v-for="(value) in columns">
              <div class="column-title">{{value.title}}</div>
              <ul class="column-list">
                <li class="list-li" :key="v.id" :class="{ 'list-li-click': v.isClick }" v-for="(v) in value.children" @click="jump(v)">{{v.name}}</li>
              </ul>
            </div>
          </div>
          <div class="footer-part2">
            <div class="part2-item part2-title">联系我们</div>
            <div class="part2-item part2-phone">023-47773287</div>
            <div class="part2-item part2-address">联系地址：重庆市江津区双福新区津马大道7号</div>
            <div class="part2-item part2-keepNo">备案号：<a class="part2-keepNo-link" target="_blank" href="https://beian.miit.gov.cn/">渝ICP备16013867号-1</a></div>
            <div class="part2-item part2-qrCode"></div>
          </div>
        </div>

      </div>
    </div>
  </template>

  <script>
    import router from '@/router'
    export default {
        name: 'Footer',
      data() {
        return {

          columns:[
            {id:0,title:'网址导航',children:[
              {id:0,name:'首页', path: '/', isActive: true,isClick:true,},
              {id:1,name:'关于我们', path: '/about', isActive: false,isClick:true,},
              {id:2,name:'产品中心', path: '/productCenter', isActive: false,isClick:true,},
              {id:3,name:'立即试用', path: '/try', isActive: false,isClick:true,},
              {id:4,name:'联系我们', path: '/contactUs', isActive: false,isClick:true,},
            ]},
            {id:1,title:'关于神缘',children:[
              {id:0,name:'公司介绍',isClick:false,},
              {id:1,name:'发展历程',isClick:false,},
              {id:2,name:'企业荣誉',isClick:false,},
            ]},
            {id:2,title:'智慧燃气',children:[
              {id:0,name:'智能民用表',isClick:false,},
              {id:1,name:'软件',isClick:false,},

            ]},
          ]
        }
      },
      methods: {
        /**
         * 导航点击跳转
        */
        jump (value) {
          if(value.path){
              router.push({
              path: value.path,
            }).catch(err => {
              console.log(err)
            })

          }

        }
      }
    }
  </script>

  <style lang="scss">
    @import './style.scss'
  </style>